import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

const exportTotalsLocalStorageName = 'puzzel_rep_exp_totals';

@Component({
    selector: 'app-dialog-download-table',
    templateUrl: './dialog-download-table.component.html',
    styleUrls: ['./dialog-download-table.component.scss'],
    standalone: false
})
export class DialogDownloadTableComponent implements OnInit {
    public fileName: string;
    public fileType: string;
    public reportCode: string;
    public fileTypes: string[];
    public isChart: boolean;
    public imgWidth: number = 1900;
    public imgHeight: number = 1000;
    public isTotalChecked: boolean = false;

    constructor(
        public dialogRef: MatDialogRef<DialogDownloadTableComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
            this.fileName = data.fileName;
            this.fileType = data.fileType;
            this.reportCode = data.reportCode;
            this.fileTypes = data.fileTypes;
            this.isChart = data.isChart;
        }

    ngOnInit(): void {
      if (localStorage.getItem(exportTotalsLocalStorageName) == "true") this.isTotalChecked = true;
    }

    onCancel() {
        this.dialogRef.close();
    }

    onDownload() {
        this.dialogRef.close({
            fileName: this.fileName,
            fileType: this.fileType,
            imgWidth: this.imgWidth,
            imgHeight: this.imgHeight,
            isTotalChecked: this.isTotalChecked
        });
    }

    changeTotalCheckbox(value: boolean) {
        localStorage.setItem(exportTotalsLocalStorageName, value.toString());
    }

    showTotalRowOption() {
        let allowedReports = ["AgentId", "AgentNo", "ChatQ", "QDetails", "SocialQ", "DialerQ", "QDetailsAll", "QSimple", "AgentSMS", "QSurvey", "TotOview", "AgentGroup", "AgentQ", "EnqReg", "AgentPause"];
        if (allowedReports.indexOf(this.reportCode) > -1) return true
        else return false
    }
}
